import styled from 'styled-components'

export const LogoutConfirmationStyle = styled.form(props => ({
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-around",
    ...props,
}))